import React from 'react';
import CommonGeneral from '../components/CommonGeneral';
import ActualFrameworkCommon from '../components/ActualFrameworkCommon';
import MigrationType from './MigrationType';
import MigrationReason from './MigrationReason';
import css from './Migration.module.scss';

function Migration({ currentProject }) {
  return (
    <div className={css.container}>
      <div className={css.left}>
        <div className={css.general}>
          <CommonGeneral currentProject={currentProject} />
          <hr />
        </div>
        <div className={css.functionalities}>
          <MigrationType currentProject={currentProject} />
        </div>
      </div>
      <div className={css.right}>
        <div className={css.design}>
          <ActualFrameworkCommon currentProject={currentProject} />
        </div>
        <div className={css.tecnology}>
          <MigrationReason currentProject={currentProject} />
        </div>
      </div>
    </div>
  );
}

export default Migration;
